import { render } from "./LaLiturgiePage.vue?vue&type=template&id=1fe9f99d"
import script from "./LaLiturgiePage.vue?vue&type=script&lang=js"
export * from "./LaLiturgiePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__